import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyDgQm9Z-OxjjGw1c4MQmbRs5QHJO0tJk9Y",
  authDomain: "curso-370db.firebaseapp.com",
  projectId: "curso-370db",
  storageBucket: "curso-370db.appspot.com",
  messagingSenderId: "1015823533768",
  appId: "1:1015823533768:web:67d08913187edbc40f87fd",
  measurementId: "G-HT547VS5CG"
};

const app = initializeApp(firebaseConfig)

const auth = getAuth(app)
const db = getFirestore(app)
const storage = getStorage(app)

export { auth, db, storage }